module.exports = __webpack_public_path__ + "static/media/modal-backing-9-slice-web.854b7857.png";